import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  PasswordInput,
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  Filter,
} from 'react-admin';

const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput source="q" label="Search by ID, phone or name" alwaysOn />
  </Filter>
);

export const UserList = (props) => (
  <List {...props} filters={<UserFilter />}>
    <Datagrid rowClick="show">
      <TextField source="id" label="Id" />
      <TextField source="username" label="Username" />
      <TextField source="email" label="Email" />
      <TextField source="first_name" label="First name" />
      <TextField source="last_name" label="Last name" />
      <BooleanField source="is_staff" label="Is staff" />
      <BooleanField source="is_active" label="Is active" />
      <BooleanField source="is_superuser" label="Is superuser" />
      <DateField source="date_joined" label="Date joined" />
    </Datagrid>
  </List>
);

export const UserCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="username" label="Username" />
      <PasswordInput source="password" label="Password" />
      <TextInput source="email" label="Email" />
      <TextInput source="first_name" label="First name" />
      <TextInput source="last_name" label="Last name" />
      <BooleanInput source="is_staff" label="Is staff" />
      <BooleanInput source="is_active" label="Is active" defaultValue={true} />
      <BooleanInput source="is_superuser" label="Is superuser" />
    </SimpleForm>
  </Create>
);